<template>
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill="#6F4FCC" fill-opacity="0.2"/>
        <path d="M30 52C42.1503 52 52 42.1503 52 30C52 17.8497 42.1503 8 30 8C17.8497 8 8 17.8497 8 30C8 42.1503 17.8497 52 30 52Z" fill="url(#paint0_linear_7179_263391)"/>
        <path d="M30 21.1992V29.9992" stroke="#E3DCF7" stroke-width="4.4" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M30 38.8008H30.022" stroke="#E3DCF7" stroke-width="4.4" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
            <linearGradient id="paint0_linear_7179_263391" x1="30" y1="8" x2="30" y2="52" gradientUnits="userSpaceOnUse">
                <stop stop-color="#6342C5"/>
                <stop offset="1" stop-color="#8563E9"/>
            </linearGradient>
        </defs>
    </svg>
</template>
